module.exports = __webpack_public_path__ + "static/media/img_slideshow2.355a6c43.jpg";